import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import { Slider } from '../dumb/slider/Slider';
import { ServicesArea } from './services-area/ServicesArea';
import { AboutArea } from '../dumb/about-area/AboutArea';
import { CounterArea } from '../dumb/counter-area/CounterArea';
import { GalleryArea } from '../dumb/gallery-area/GalleryArea';
import { AboutWrap } from '../dumb/about-wrap/AboutWrap';
import { FinancialSolutionArea } from '../dumb/financial-solution-area/FinancialSolutionArea';
import { TestimonialArea } from '../dumb/testimonial-area/TestimonialArea';
import { ProjectArea } from './project-area/ProjectArea';
import { Footer } from '../dumb/footer/Footer';
import { TestForm } from '../dumb/test-form/TestForm';
import { ScriptContainer } from '../smart/script/ScriptContainer';
import { Loader } from './utils/loader/Loader';


type props = {}

export const Home = (props: any) => {

    //Hooks
    const [isOnline, setIsOnline] = useState(false);
    
    useEffect(() =>

        setIsOnline(true), [setIsOnline, isOnline]
    );

    if (isOnline === false) {
        
        return <Loader />
    }
    else {
        $('body').animate(
            {
                scrollTop: 0
            },
            2000
        );
        return <div id="homeless-container">
        {/**slider component */}
        <Slider />
        {/**service area component */}
        <ServicesArea clickhandler={props.clickhandler}/>
        {/**about area component */}
        <AboutArea clickhandler={props.clickhandler}/>
        {/**counter area component */}
        {/* <CounterArea /> */}
        {/**gallery area component */}
        {/* <GalleryArea /> */}
        {/**about wrap component */}
        {/* <AboutWrap /> */}
        {/**financial solution area component */}
        {/* <FinancialSolutionArea /> */}
        {/**testimonial area component */}
        {/* <TestimonialArea /> */}
        {/**project area component */}
        <ProjectArea {...props} clickhandler={props.clickhandler}/>
        {/**footer area component */}
        <Footer {...props} clickhandler={props.clickhandler}/>
        {/**test form component */}
        <TestForm />
        {/**public scripts loader */}
        <ScriptContainer {...props} count={props.count}/>
    </div>
    }
}
